<div class="card">
  <span class="sold-tag" *ngIf="isSold">SOLD</span>
  <img [src]="vehicleImage" [alt]="vehicleName" class="card-img" />
  <h2 class="card-heading">{{ vehicleName }}</h2>
  <button class="card-btn">View Details</button>
</div>
